<template>
  <section
    :class="{
      'faq-accordion-component': true,
    }"
  >
    <GeneralTheme :theme="configuration">
      <div :class="{ 'container mx-auto': !fullWidthContent }">
        <FAQAccordion
          v-if="props.FAQAccordion"
          v-bind="props.FAQAccordion"
        />
      </div>
    </GeneralTheme>
  </section>
</template>

<script setup lang="ts">
import FAQAccordion from '~/components/Atmos/Accordion/FAQAccordion.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderFAQAccordion } from '~/sanity/types';
const props = defineProps<SectionBuilderFAQAccordion>();
</script>

<style></style>
